import { isEqual, isPlainObject, reduce } from "lodash";
import { AttachmentApi } from "./AttachmentApi";
import { ListApi } from "./ListApi";

let guid = function() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

let getDupeCheckFilters = function (nameIn,cityIn) {
    let fuzzy = 0.78;
    let nameFilter = cleanString(nameIn).split(" ")
        .filter(word => word.trim() !== "")
        .map(word => `+Name:${word}~${fuzzy}`)
        .join(" ");
    let searchStrings = [nameFilter];
    let city = cleanString(cityIn);
    if (city && city.length) {
        let cityFilter = city.split(" ")
            .filter(word => word.trim() !== "")
            .map(word => `+City:${word}~${fuzzy}`)
            .join(" ");
        searchStrings = [`(${nameFilter} AND ${cityFilter})`];
    } else {
        searchStrings = [`(${nameFilter} AND -City:[* TO *])`];
    }
    return searchStrings;
}

let cleanString = function (inputString) {
    if (inputString && inputString != "") {
        const removeList = [
            "GmbH", "AG", "KG", "e.K.", "S.A.", "Inc.", "Ltd.", "LLC", "Co.", "Ltd",
            "Srl", "NV", "B.V.", "Pty", "PLC", "AS", "SARL", "Cie", "S.A.R.L."
        ];
        let cleanedString = inputString.toString();
        removeList.forEach(item => {
            const escapedItem = item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const useWordBoundaries = /^[\w]+$/.test(item);
            const pattern = new RegExp(useWordBoundaries ? `\\b${escapedItem}\\b` : escapedItem, 'gi');
            cleanedString = cleanedString.replace(pattern, '');
        });
        cleanedString = cleanedString.replace(/[^\w ]/g, '');
        cleanedString = cleanedString.replace(/\s+/g, ' ').trim();
        if (!cleanedString.length)
            return "";
        console.log("cleanedString", cleanedString);
        return cleanedString;
    }
}

let askForImage = function (acceptAllInputs) {
    let i = document.createElement("input")
    return new Promise((res, rej) => {
        try {
            i.type = "file";
            i.accept = "image/*";
            if (!acceptAllInputs)
                i.capture = "environment";
            i.multiple = false;
            i.style.position = "absolute";
            i.style.width = "1px";
            i.style.height = "1px";
            i.style.padding = "0";
            i.style.margin = "-1px";
            i.style.overflow = "hidden";
            i.style.clip = "rect(0,0,0,0)";
            i.style.border = "0";
            i.addEventListener('change', () => {
                try {
                    res(i.files[0])
                } catch (e) {
                    rej(e);
                }
                i.remove();
            });
            i.addEventListener('cancel', () => {
                rej("cancel");
            });
            i.addEventListener('abort', () => {
                rej("abort");
            });

            document.body.appendChild(i);
            let evt = new MouseEvent("click");
            (evt) ? i.dispatchEvent(evt) : (i.click && i.click());
            // i.click();
        } catch (ex) {
            rej(ex);
        }
    }).finally(() => i.remove());
    
}
class LuceneConverter {
    toPascalCase(str) {
        if (!str)
            return str;
        return str[0].toUpperCase() + str.substring(1);
    }
    anyOf(fields) {
        if (!fields)
            return "";
        return "(" + fields.map(f => '"' + this.escape(f) + '"').join(" ") + ")"
    }
    escape(str) {
        if (!str)
            return str;
        return str.replace(/[+\-!(){}[\]^\\?*"~:&|]/g, r => "\\" + r);
    }
    handleItem(item) {
        let field = this.toPascalCase(item[0]);
        let operator = item[1];
        let value = item[2];

        if (operator == "=") {
            return `${field}:"${this.escape(value)}"`
        }
        if (operator == ":") {
            return `${field}:${value}`
        }
        if (operator == "contains") {
            return `${field}:*${this.escape(value)}*`
        }
        if (operator == "startswith") {
            return `${field}:${this.escape(value)}*`
        }
        if (operator == "endswith") {
            return `${field}:*${this.escape(value)}`
        }
        if (operator == "notcontains") {
            return `(${field}:* NOT ${field}:*${this.escape(value)}*)`
        }
        if (operator == "<>") {
            return `(${field}:* NOT ${field}:"${value}")`
        }
        if (operator.startsWith(">")) {
            return `${field}:[${this.toLucene(value)} TO *]`
        }
        if (operator.startsWith("<")) {
            return `${field}:[* TO ${this.toLucene(value)}]`
        }
        if (operator == "between") {
            try {
                value = JSON.parse(value);
                return `${field}:[${value[0]} TO ${value[1]}]`
            }
            catch {
                console.error("[ERR] Between not correct value!", item, value);
                throw new Error("Between not correct value!")
            }

        }
    }
    combineRanges(filter) {
        /*
            Expressions like:
            ["Price",">=",545],
            "and",
            ["Price","<=",566]
            Will be converted to:
            ["Price","between","[545,566]"]
            The 3rd part will be JSON
        */
        if (!Array.isArray(filter) || filter.length != 3)
            return filter;
        if (!Array.isArray(filter[0]) || filter[0].length != 3)
            return filter;
        if (!Array.isArray(filter[2]) || filter[2].length != 3)
            return filter;
        if (filter[1] != "and")
            return filter;
        if (typeof (filter[0][1]) !== "string" || !filter[0][1].startsWith(">"))
            return filter;
        if (typeof (filter[2][1]) !== "string" || !filter[2][1].startsWith("<"))
            return filter;
        if (typeof (filter[0][0]) !== "string" || typeof (filter[2][0]) !== "string")
            return filter;
        if (filter[0][0] != filter[2][0])
            return filter;
        return [filter[0][0], "between", JSON.stringify([this.toLucene(filter[0][2]), this.toLucene(filter[2][2])])]
    }
    toLucene(filter) {
        filter = this.combineRanges(filter);
        if (Array.isArray(filter)) {
            if (filter.length == 3 && filter.every(i => typeof (i) === 'string')) {
                return this.handleItem(filter)
            }
            return "(" + filter.map(item => {
                return this.toLucene(item);
            }).join("") + ")";
        }
        if (typeof (filter) == 'string') {
            if (filter === "or")
                return " OR ";
            else if (filter === "and")
                return " AND ";
            else if (/\d{4}-\d\d-\d\dT\d\d:\d\d:\d\dZ/.test(filter))
                return filter.replace(/[-T:]/g, "").substring(0, 12)
            else
                return filter;
        }
        if (typeof (filter) === "boolean")
            return filter ? "1" : "0";
        if (typeof (filter) === "object" && new Date(filter).toString() !== "Invalid Date")
            return new Date(filter).toJSON().replace(/[-T:]/g, "").substring(0, 12);
        console.error("[ToLucene] DID NOT HANDLE: ", filter);
    }
}

let luceneConverter = new LuceneConverter();

const diffrenceObjects = function (obj1, obj2) {
    return reduce(obj1, function (result, value, key) {
        if (isPlainObject(value)) {
            result[key] = diffrenceObjects(value, obj2[key]);
        } else if (!isEqual(value, obj2[key])) {
            result[key] = value;
        }
        return result;
    }, {});
};


async function managementTransferImages() {
    let listItemsWithImages = (await Promise.all((await Promise.all((await ListApi.getAll()).filter(l => l.allowImage).map(l => ListApi.getListItems(l._id).then(d => d.map(dd => [l, dd]))))).flat().filter(notNull => notNull).map(li => AttachmentApi.getByAssignment('system', 'listItems', li[1]._id + '.png').then(d => [li[0].name + "->" + li[1].value, d])))).filter(t => t[1])
    function blobToBase64(blob) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
    for (let item of listItemsWithImages) {
        item[2] = await blobToBase64(await AttachmentApi.getBlob(item[1]._id))
    }
    return listItemsWithImages;
}
async function managementTransferImagesUpload(allTheData) {
    let listItems = (await Promise.all((await ListApi.getAll()).filter(l => l.allowImage).map(l => ListApi.getListItems(l._id).then(d => d.map(dd => [l, dd]))))).flat().filter(notNull => notNull)
    for (let item of listItems) {
        let id = item[0].name + "->" + item[1].value;
        let match = allTheData.find(atd => atd[0] == id);
        if (match && match[2]) {
            let att = await AttachmentApi.getByAssignment('system', 'listItems', item[1]._id + '.png');
            if (!att) {
                att = await AttachmentApi.save({ assignmentType: 'system', assignment: 'listItems', type: item[0]._id, name: item[1]._id+ '.png' })
            }
            await AttachmentApi.saveBlob(att._id, await fetch(match[2]).then(res => res.blob()))
            console.log("created",id,att._id)
        }
    }
}
window.managementTransferImages = managementTransferImages;
window.managementTransferImagesUpload = managementTransferImagesUpload;
export {
    diffrenceObjects,
    guid,
    askForImage,
    luceneConverter,
    cleanString,
    getDupeCheckFilters,
    managementTransferImages,
    managementTransferImagesUpload
}
